import { getRequest } from 'config/Axios/baseConfig';
import { HourlyBphResponse } from 'screens/CalculationsScreen/components/HourlyBPHByRoom/hourlybphByRoom.type';

export const hourlyBPHbyRoomService = {
  getHourlyBPHbyRoom: (date: string): Promise<HourlyBphResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const respose = await getRequest<HourlyBphResponse>(
          `pps/calculations/hourly-bph-by-rooms/${date}`
        );
        resolve(respose.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
